<style lang="scss">
    .pin-activation {
        .h2 {
            color: #ff5855;
        }

        .pin-separator {
            border-bottom: 1px solid rgb(208, 208, 208);
        }
    }
    #div-activado{
        border-style: solid;
        border-color: #ff5855;
        margin-left: 10px;
        margin-bottom: 10px;
        padding: 2px;
        font-size: 10px;
        font-weight: bold;
        color: #ff5855;
    }
</style>

<template>
    <div class="pin-activation">
        <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
        <b-card style="margin: 20px">
            <b-card-body>
                <div class="row pin-separator">
                    <div class="form-check-inline">
                        <Label class="h2">PIN</Label>
                        <resimple-switch v-if="ShouldPerformTwoStepVerification == false" class="ml-2" v-model="usePaymentPin" v-on:change="onChangeResimpleSwitch"/>
                        <div v-if="ShouldPerformTwoStepVerification" id="div-activado">{{messageDivActivado}}</div>
                    </div>
                </div>
                <div class="row mt-2 pin-separator" v-if="usePaymentPin">
                    <a href="#" class="h2" v-on:click="goToPinConfiguration">Cambiar PIN</a>
                </div>
                  <div class="row mt-2 pin-separator" v-if="ShouldPerformTwoStepVerification">
                    <a href="#" class="h2" v-on:click="goToPinConfigurationWithForgotMyPIN">Olvidé PIN</a>
                </div>
                <div class="row mt-3">
                    <span>Activa la solicitud de PIN para operaciones que impliquen salida de dinero como Pagos con QR o Transferencias.</span>
                </div>
            </b-card-body>
        </b-card>
        <pin-validation ref="pin-validation"
            :showModal.sync="showModalPinValidation" 
            v-on:validPin="onValidPin" 
            v-on:loadUsePaymentPin="onLoadUsePaymentPin">
        </pin-validation>
    </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import ResimpleSwitch from "@/components/Custom/ResimpleSwitch";
import PinValidation from '@/views/Pin/PinValidation';

export default {
    name: "PinActivation",
    components: {
        "resimple-switch": ResimpleSwitch,
        "pin-validation": PinValidation
    },
    data() {
        return {
            usePaymentPin: false,
            showModalPinValidation: false,
            ShouldPerformTwoStepVerification: false,
            messageDivActivado: ""
        };
    },
    watch: {
        showModalPinValidation(val) {
            var validateButtonPressed = this.$refs["pin-validation"].validateButtonPressed;
            // Si el modal se cerró sin presionar el boton 'validar'
            if(!val && !validateButtonPressed) {
                // Vuelvo para atrás el valor del switch
                this.usePaymentPin = !this.usePaymentPin;
            }
        }
    },
    computed: {
        pin() {
            return (this.$refs["pin-validation"].pin != null || this.$refs["pin-validation"].pin != undefined) ? this.$refs["pin-validation"].pin : '';
        }
    },
    methods: {
        setStatusUsePin(context) {
            let req = { NewStatus: context.usePaymentPin, Pin: context.pin }
            axiosHelpers.axiosPost("Account/SetStatusUsePin", req, context, function(data) {
                if(!data.ResponseVM.Result) {
                    // Si falla vuelvo para atrás el valor del switch
                    context.usePaymentPin = !context.usePaymentPin;
                } else {
                    location.reload();
                }
            });
        },
        onChangeResimpleSwitch() {
            if(!this.usePaymentPin) {
                this.showModalPinValidation = true;
            } else {
                if(this.pin != '') {
                    this.setStatusUsePin(this); 
                } else {
                    this.$router.push({
                        name: "pinconfiguration",
                        params: {
                            currentPinProp: this.pin,
                            // activatePinProp: true,
                            forgotMyPINProp: true,
                            routeGoToAfterFinishProp: 'pin'
                        }
                    });
                }
            }
        },
        onValidPin(val) {
            if(val) {
                this.setStatusUsePin(this);
            } else {
                // Si el pin no es valido vuelvo para atrás el valor del switch
                this.usePaymentPin = !this.usePaymentPin;
            }
        },
        onLoadUsePaymentPin(val) {
            this.usePaymentPin = val;
        },
        goToPinConfiguration() {            
            this.$router.push({name: "pinconfiguration", params: { currentPinProp: this.pin }});
        },
        goToPinConfigurationWithForgotMyPIN() {   
            let context = this; 
            context.$router.push({name:"selectSecurityMethod", params:{
                    accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
                    useRouterPush: true, dataPost:{name:"pinconfiguration", params:{
                    currentPinProp: context.pin, forgotMyPINProp: true, routeGoToAfterFinishProp: "/dashboard"
            }}
            }});        
        }
    },
     beforeMount: function() {
let context= this;
context.ShouldPerformTwoStepVerification  = context.$store.getters.ShouldPerformTwoStepVerification;

if(context.$store.getters.ShouldPerformTwoStepVerification){
    context.messageDivActivado ="Activado"} else {
 context.messageDivActivado ="Desactivado"
}

     }
}
</script>